"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_2 = require("@osmosys/react");
const react_loops_1 = require("react-loops");
const reusables_1 = require("../../../comps/reusables");
const Item_1 = require("./Item");
const hooks_1 = require("../hooks");
const use_debounce_1 = require("use-debounce");
const utils_1 = require("../utils");
exports.ContentImportPanelContentListInner = () => {
    const { contentItemsResult: result, searchQuery, showSearch, contentFeed, } = hooks_1.useContentImportPanelData();
    // Debounce searchQuery
    const [searchQueryDebounced] = use_debounce_1.useDebounce(searchQuery, 400, {
        maxWait: 800,
    });
    // Return results (filtering if needed to when searching)
    const filteredResults = react_1.useMemo(() => {
        if (result.data && result.data.contentItems) {
            if (showSearch && searchQueryDebounced && searchQueryDebounced.trim()) {
                return utils_1.searchContentItems(searchQueryDebounced.trim(), result.data.contentItems);
            }
            return result.data.contentItems.map(ci => {
                return {
                    item: ci,
                    matches: [],
                    score: 0,
                };
            });
        }
        return [];
    }, [result.data, showSearch, searchQueryDebounced]);
    // Show loading state
    if (result.loading) {
        return react_1.default.createElement(reusables_1.Loading, { useContainer: true, message: "Getting content items..." });
    }
    const hasSearch = !!(showSearch || searchQueryDebounced);
    const showAsPlaceholder = searchQuery !== searchQueryDebounced;
    const contentPushIsEnabled = !!contentFeed.contentPushIsEnabled;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_loops_1.For, { of: filteredResults, ifEmpty: react_1.default.createElement(react_2.OsmosysDiv, { flexColCenteredFilled: true },
                react_1.default.createElement(react_2.OsmosysDiv, { flexRowCentered: true },
                    react_1.default.createElement("div", { style: { maxWidth: 200 } },
                        react_1.default.createElement(react_2.OsmosysUndesiredState, { message: "No content items found", description: hasSearch
                                ? 'Tip: if you have any special characters in your search, remove them to expand your query.'
                                : contentPushIsEnabled
                                    ? 'Has any content been pushed to this feed?'
                                    : 'Was the content mapping for this feed set up?' })))) }, (contentItem, meta) => {
            return (react_1.default.createElement(Item_1.ContentImportPanelContentListItem, Object.assign({ contentItemResult: contentItem, placeholder: showAsPlaceholder }, meta)));
        })));
};
//# sourceMappingURL=Inner.js.map